'use client';

import { Box } from '@mui/material';

import { useCallback, useState } from 'react';
import { SwiperClass } from 'swiper/react';

import { ProductImages } from './ProductImages';
import { ProductImagesModal } from './ProductImagesModal';

import { ProductImage } from './ProductImage';
export interface ProductGalleryProps {
  /**
   * The images to display in the gallery.
   */
  images: ProductImage[];
}

export function ProductGallery({ images }: ProductGalleryProps) {
  // we will sync the swipers using refs exposed by ProductImages
  // .. note that we need to re-render when the swipers are assigned, so we'll use a state hook instead of useRef
  const [gallerySwiper, setGallerySwiper] = useState<SwiperClass | null | undefined>();
  const [modalSwiper, setModalSwiper] = useState<SwiperClass | null | undefined>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const onOpenImageModal = useCallback(() => {
    // n.b. the modal swiper is already synced to the gallery swiper through the controlled prop below

    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const onCloseImageModal = useCallback(() => {
    // sync the gallery swiper to the modal swiper on close
    gallerySwiper?.slideTo(modalSwiper?.realIndex ?? 0);

    setIsModalOpen(false);
  }, [setIsModalOpen, gallerySwiper, modalSwiper]);

  return (
    <Box>
      <ProductImages
        swiper={setGallerySwiper}
        controlled={modalSwiper}
        images={images}
        onOpenModal={onOpenImageModal}
        className={'gallery-swiper'}
      />
      <ProductImagesModal
        swiper={setModalSwiper}
        images={images}
        open={isModalOpen}
        onClose={onCloseImageModal}
      />
    </Box>
  );
}
